import type { RouteRecordRaw } from 'vue-router';
import { SETUP_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupPaymentMethodRoutes: RouteRecordRaw = {
  path: '/setup/payment-method-management',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    { name: SETUP_ROUTE_NAME.PAYMENT_METHOD_MANAGEMENT, path: '', component: () => import('./SetupPaymentMethod.vue') },
  ],
};
